import React from 'react';
import { Modal, Button } from 'react-bootstrap';

const DeleteConfirmModal = ({ show, onHide, onConfirm, pipelineName }) => {
  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Body className="text-center p-5">
        <h5>Are you sure you want to delete <strong>{pipelineName}</strong>?</h5>
        <p className="text-muted mt-3">This action cannot be undone.</p>
      </Modal.Body>
      <Modal.Footer className="border-0 justify-content-center gap-3 pb-4">
        <Button variant="light" onClick={onHide}>Cancel</Button>
        <Button variant="danger" onClick={onConfirm}>Yes, Delete</Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DeleteConfirmModal;